import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './catalog-section-table-cell.scss?inline';

export default class SotbitCatalogSectionTableCell extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        sortIcon: { type: String, attribute: 'sort-icon' },
        variant: { type: String },
    };

    render() {
        return html`
            <div class="cell-wrapper">
                <div class="cell" part="cell">
                    <slot name="content"></slot>
                    ${this.sortIcon && this.sortIcon.length > 0
                        ? html`<sotbit-icon
                              class="cell-icon"
                              icon="${this.sortIcon}"
                              size="m"
                              no-padding
                          ></sotbit-icon>`
                        : ''}
                </div>
                <div class="outline"></div>
            </div>
        `;
    }
}
